import script from "./DentalIpdBilling.vue?vue&type=script&setup=true&lang=js"
export * from "./DentalIpdBilling.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__